import React, { useState } from "react";
import { ReactComponent as PayTypeIc } from "../../assets/svg/payment_ty_ic.svg";
import profileIc from "../../assets/png/profile-ic.png";
import ProfileImageModal from "../common/common-preview";

const PurchaseOrderTab = ({
  vendorHistoryList,
  hoveredIndex,
  setHoveredIndex,
}) => {
  const [showProfilePopup, setShowProfilePopup] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState("");
  return (
    <>
      <ProfileImageModal
        show={showProfilePopup}
        onClose={() => setShowProfilePopup(false)}
        imageUrl={selectedProfile}
      />
      <div
        style={{
          display: "flex",
          flex: "10",
          paddingLeft: "16px",
          paddingRight: "16px",
          paddingTop: "16px",
          height: "40px",
          backgroundColor: "#F2F2F2",
        }}
        className="head3 w-100 justify-content-center align-items-center"
      >
        <p
          style={{ width: "127px", flex: "1" }}
          className="fs-13 fw-700 textcolor"
        >
          Order No
        </p>
        <p
          style={{ width: "160px", flex: "1" }}
          className="fs-13 fw-700 textcolor"
        >
          Vendor
        </p>
        <p
          style={{ width: "160px", flex: "1" }}
          className="fs-13 fw-700 textcolor"
        >
          Payment Type
        </p>{" "}
        <p
          style={{ width: "160px", flex: "1" }}
          className="fs-13 fw-700 textcolor"
        >
          Payment Status
        </p>{" "}
        <p
          style={{ width: "160px", flex: "1" }}
          className="fs-13 fw-700 textcolor"
        >
          Amount
        </p>{" "}
        <p
          style={{ width: "160px", flex: "1" }}
          className="fs-13 fw-700 textcolor"
        >
          Status
        </p>{" "}
      </div>
      <div>
        {(vendorHistoryList ?? []).map((item, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              flex: "10",
              paddingLeft: "16px",
              paddingRight: "16px",
              backgroundColor: hoveredIndex === index ? "#FAFAFA" : "#FFFFFF",
              borderBottom: "1px solid #D4DDE7",
              cursor: "pointer",
              height: "44px",
            }}
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
            className="head3 w-100 justify-content-center align-items-center"
          >
            {" "}
            <p
              className="fs-13 fw-500 textcolor"
              style={{
                flex: "1",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
                marginTop: "16px",
              }}
              title={item.order_no ?? ""}
            >
              {item.order_no ?? "---"}
            </p>
            <p
              className="fs-13 fw-500 textcolor"
              style={{
                flex: "1",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
                marginTop: "16px",
              }}
              title={item.vendor_name ?? "---"}
            >
              <img
                key={index}
                src={
                  item.image && item.image.trim() !== ""
                    ? item.image
                    : profileIc
                }
                alt="Profile"
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedProfile(
                    item.image && item.image.trim() !== ""
                      ? item.image
                      : profileIc,
                  );
                  setShowProfilePopup(true);
                }}
                className="avatar-item me-1 ms-0"
              />
              {item.vendor_name ?? "---"}
            </p>
            <div
              className="fs-13 fw-500 textcolor"
              style={{
                flex: "1",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
              }}
              title={item.payment_type}
            >
              <div
                className="px-3"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "6px",
                  height: 24,
                  backgroundColor: "#E6E4FF",
                  borderRadius: "100px",
                  whiteSpace: "nowrap",
                }}
              >
                <PayTypeIc /> {item.payment_type ?? "---"}
              </div>
            </div>
            <p
              className="fs-13 fw-500 textcolor"
              style={{
                flex: "1",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
                marginTop: "16px",
              }}
              title={item.payment_status}
            >
              {item.payment_status ?? "---"}
            </p>
            <p
              className="fs-13 fw-500 textcolor"
              style={{
                flex: "1",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
                marginTop: "16px",
              }}
              title={item.total}
            >
              {item.total ?? "---"}
            </p>
            <p
              className="fs-13 fw-500 textcolor"
              style={{
                flex: "1",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
                marginTop: "16px",
              }}
              title={item.po_status ?? ""}
            >
              <span
                className="backgroundYellow mx-2"
                style={{
                  width: "10px",
                  height: "10px",
                  borderRadius: "3px",
                  display: "inline-block",
                }}
              ></span>{" "}
              {item.po_status ?? "---"}
            </p>
          </div>
        ))}
      </div>
    </>
  );
};

export default PurchaseOrderTab;
